import { useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { inputCls, btnPrimary } from "@/components/Form";
import AuthCard from "@/components/AuthCard";

const only = (v, n) => v.replace(/\D/g, "").slice(0, n);
export const fmtDoc = (v = "") => {
  const d = only(v, 14);
  if (d.length <= 11) return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  return d.replace(/^(\d{2})(\d)/, "$1.$2").replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3").replace(/\.(\d{3})(\d)/, ".$1/$2").replace(/(\d{4})(\d)/, "$1-$2");
};
export const fmtPhoneBr = (v = "") => only(v, 11).replace(/^(\d{2})(\d)/, "($1) $2").replace(/(\d)(\d{4})$/, "$1-$2");

const Field = ({ label, children }) => (
  <label className="block"><span className="mb-1.5 block text-xs font-semibold uppercase tracking-wider text-slate-600">{label}</span>{children}</label>
);

export default function CompleteClientInfo() {
  const { user, refresh, signOut } = useAuth();
  const [f, setF] = useState({ name: user.name || "", document: fmtDoc(user.document || ""), phone: fmtPhoneBr(user.phone || "") });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.put("/me/client-info", f); toast.success("Cadastro completo! Suas 10 contestações grátis foram liberadas."); await refresh(); }
    catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <AuthCard eyebrow="Teste grátis" title="Complete seu cadastro" desc="Informe seus dados para liberar suas 10 contestações grátis.">
      <form onSubmit={submit} className="space-y-4" data-testid="client-info-form">
        <Field label="Nome completo"><input data-testid="client-info-name-input" required minLength={3} placeholder="Seu nome" className={inputCls} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} /></Field>
        <Field label="CPF ou CNPJ"><input data-testid="client-info-document-input" required inputMode="numeric" placeholder="000.000.000-00" className={inputCls} value={f.document} onChange={(e) => setF({ ...f, document: fmtDoc(e.target.value) })} /></Field>
        <Field label="Telefone com DDD"><input data-testid="client-info-phone-input" required inputMode="tel" placeholder="(11) 90000-0000" className={inputCls} value={f.phone} onChange={(e) => setF({ ...f, phone: fmtPhoneBr(e.target.value) })} /></Field>
        <Field label="E-mail (não editável)"><input data-testid="client-info-email-input" disabled value={user.email} className={`${inputCls} cursor-not-allowed border-dashed bg-slate-100 text-slate-500`} /></Field>
        <button data-testid="client-info-submit-btn" disabled={busy} className={`${btnPrimary} w-full`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />}Liberar contestações grátis</button>
      </form>
      <button data-testid="client-info-logout-btn" onClick={signOut} className="mt-4 w-full text-center text-sm text-slate-500 hover:underline">Sair</button>
    </AuthCard>
  );
}
